import { useEffect, useMemo, useState } from "react";
import useI18nContext from "../hooks/general/useI18nContext";
import Dialog from "./Dialog";
import { CSVLink } from "react-csv";
import { Button, CircularProgress, Stack } from "@mui/material";

export default function DownloadDialog({ open, onClose, formatterFunction, data }) {
  const { t } = useI18nContext();
  const [csvData, setCsvData] = useState(null);

  useEffect(() => {
    let isMounted = true;

    async function run() {
      if (data?.length > 0) {
        try {
          const d = await formatterFunction(data, t);
          if (isMounted) setCsvData(d);
        } catch (e) {
          console.error("Failed to build CSV data", e);
          if (isMounted) setCsvData(null);
        }
      } else {
        setCsvData(null);
      }
    }

    run();

    return () => {
      isMounted = false;
    };
  }, [data, formatterFunction, t]);

  const firstNameOnlyCsv = useMemo(() => {
    if (!csvData || !Array.isArray(csvData) || csvData.length === 0) return null;

    const [headerRow, ...rows] = csvData;

    const nameColIndex = headerRow.indexOf("שם מלגאי/ת");
    if (nameColIndex === -1) {
      return csvData;
    }

    const newRows = rows.map((row) => {
      const newRow = [...row];
      const fullName = newRow[nameColIndex];

      if (typeof fullName === "string") {
        const firstName = fullName.trim().split(/\s+/)[0];
        newRow[nameColIndex] = firstName;
      }

      return newRow;
    });

    return [headerRow, ...newRows];
  }, [csvData]);

  const isLoading = !csvData;
  const downloadFullNameLabel = t?.downloadFullName || t?.download || "Download (full name)";
  const downloadFirstNameLabel =
    t?.downloadFirstName || t?.download || "Download (first name only)";

  return (
    <Dialog
      maxWidth="xs"
      fullWidth
      title={t?.download}
      open={open}
      onClose={onClose}
    >
      <Stack spacing={2}>
        {isLoading ? (
          <Button fullWidth variant="contained" disabled>
            <CircularProgress color="inherit" size={26} />
          </Button>
        ) : (
          <CSVLink
            data={csvData}
            filename="users-list.csv"
            style={{ textDecoration: "none" }}
          >
            <Button fullWidth variant="contained">
              {downloadFullNameLabel}
            </Button>
          </CSVLink>
        )}

        {!firstNameOnlyCsv ? (
          <Button fullWidth variant="outlined" disabled>
            <CircularProgress size={26} />
          </Button>
        ) : (
          <CSVLink
            data={firstNameOnlyCsv}
            filename="users-list-first-name-only.csv"
            style={{ textDecoration: "none" }}
          >
            <Button fullWidth variant="outlined">
              {downloadFirstNameLabel}
            </Button>
          </CSVLink>
        )}
      </Stack>
    </Dialog>
  );
}
